import { throttle } from "lodash-es";

function triggerAnimation(targets, delayTime = 300, count_delay = 0) {
  const notAnimatedTarget = targets.filter((target) => !target.classList.contains("animated"));
  if (notAnimatedTarget.length === 0) {
    return "done";
  }
  notAnimatedTarget.forEach((target) => {
    const rectTop = target.getBoundingClientRect().top;

    if (rectTop < window.innerHeight + 50) {
      setTimeout(() => {
        target.classList.add("animated");
      }, count_delay * delayTime);
    }
    if (rectTop > 0) count_delay++;
  });
  return "success";
}

window.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll("[data-scroll-animation]:not(.animated)");
  triggerAnimation(targets);
  const handleScrollAnimate = throttle(() => {
    const result = triggerAnimation(targets);
    if (result === "done") window.removeEventListener("scroll", handleScrollAnimate);
  }, 300);
  window.addEventListener("scroll", handleScrollAnimate);
});
